import script from "./AEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./AEvent.vue?vue&type=script&setup=true&lang=js"

import "./AEvent.vue?vue&type=style&index=0&id=816d419a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-816d419a"]])

export default __exports__